import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface PreviewLogoResponse extends BackendResponse {
  item: string;
}

export interface PreviewLogoParameters extends NextApiParams {
  /**
   * file: File;
   * verifyIdConcernWithAppTenant: number;
   * cvportalLogoType: CvpLogoType;
   * idEmbed: string;
   */
  formData: FormData;
}

export const previewLogo = withNextApi<
  PreviewLogoResponse,
  PreviewLogoParameters
>("/cvp/CvpPreviewLogo");
